<template>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <fade-render-transition>
        <form @submit.prevent.stop="login">
            <div slot="header">
              <h3 class="card-title text-center">Login</h3>
            </div>
            <div class="text-center">
              <el-input type="search"
                        placeholder="ID"
                        v-model="accountID"/>
            </div>
            <div class="text-center">
              <el-input type="password"
                        placeholder="PASSWORD"
                        v-model="accountPassword"/>
            </div>
            <div class="text-center">
              <button type="submit" v-show="loginable" class="btn btn-fill btn-info btn-round btn-wd ">Login</button>
            </div>
        </form>
        </fade-render-transition>
      </div>
    </div>
</template>
<script>
import { Checkbox as LCheckbox, FadeRenderTransition } from 'src/components/index'
import { Input } from 'element-ui'
import swal from 'sweetalert2'
import {Company as api}  from 'api'

export default {
  components: {
    [Input.name]: Input,
    LCheckbox,
    FadeRenderTransition,
  },
  data () {
    return {
      accountID: undefined,
      accountPassword: undefined,
      loginable:true,
    }
  },
  methods: {
    login (formData) {
      if (!this.loginable) return
      this.loginable = false
      const accountPassword = this.accountPassword
      const formData1 = this.accountID
      this.$store.dispatch('login', {accountID:formData1, accountPassword:accountPassword}).then(()=>{
        this.$router.push('/')
        api.get(this.$store.state.accountID, this.$store.state.companyID).then(({data})=>{
          window.HOSPITAL_NAME = data.companyName
          window.COMAPNY_DETAIL = data
        })
      }).catch(reason=>{
        const s = JSON.stringify(reason)
        if (s) {
          swal(s)
        } else {
          swal("문제가 생겼습니다.")
        }
        this.loginable = true
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }

  .text-center {
    margin-top: 1em;
  }

</style>



// WEBPACK FOOTER //
// src/pages/GeneralViews/Login.vue